<template>
  <div class="login-bg">
    <div
      class="login-cont container"
      style="height: 80vh;"
    >
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <!-- <img
            class="mx-auto mb-4"
            src="https://storage.googleapis.com/spacetech2/phoenix888/PHONIX%20MAIN.webp"
            alt=""
            @click="$router.push('/home')"
            style="height: 10rem"
          /> -->
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(255, 255, 255, 0.25);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(10px);-webkit-backdrop-filter: blur(10px);"
          >
            <div class="my-auto col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>

                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.phone }}</small>
                <div class="form-group mb-3">
                  <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.phone') }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: linear-gradient(5deg, rgb(202, 138, 4) 0%, rgb(255, 255, 255) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative"
                    > -->
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: linear-gradient(5deg, rgb(202, 138, 4) 0%, rgb(255, 255, 255) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password text-dark"
                      v-if="isShow"
                      @click="showablePassword()"
                    ></i>
                    <i
                      v-if="!isShow"
                      class="fas fa-eye-slash showable-password text-dark"
                      @click="showablePassword()"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <div class="text-center mt-3">
                  <button
                    type="button"
                    class="btn my-4"
                    style="background: white; color: black; border-radius: 20px; width: 10rem; box-shadow: none;"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.login') }}
                    </div>

                    <Loading
                      color="#000000"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <div
                  v-if="showQuickLogin"
                  class="text-center mt-1 mb-2"
                >
                  <button
                    type="button"
                    class="btn text-nowrap"
                    style="background: linear-gradient(135deg, #fde047 0%, #facc15 45%, #eab308 100%); color: #1e1b4b; border-radius: 20px; min-width: 5.5rem; padding-left: 0.65rem; padding-right: 0.65rem; box-shadow: none; font-weight: 600;"
                    @click="quickLogin"
                  >
                    <span v-if="!isQuickLogin">
                      <i class="fas fa-bolt mr-1"></i>{{ $t('auth.quick_login') }}
                    </span>
                    <Loading
                      v-else
                      color="#1e1b4b"
                      size="20"
                      class="px-2 py-0"
                    />
                  </button>
                </div>
                <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div> 
                      <div class="my-auto text-dark px-3">OR</div>
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #16a34a; color: white; border-radius: 20px; width: 14rem; box-shadow: none;"
                        @click="$router.push('/auth/register')"
                      >
                        <div>
                          {{$t('auth.sign_up')}}
                        </div>
                      </button>
                    </div>
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isQuickLogin: false,
      isShow: false,
    };
  },
  computed: {
    isPlay2Subdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play2' || host.startsWith('play2.');
    },
    isPlaySubdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play' || host.startsWith('play.');
    },
    showQuickLogin() {
      return this.isPlaySubdomain || this.isPlay2Subdomain;
    },
    playHostPlatform() {
      if (this.isPlay2Subdomain) return 'Telegram';
      if (this.isPlaySubdomain) return 'TikTok';
      return null;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = 'password';
      } else {
        this.$refs.password.type = 'text';
      }
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name = this.$t('auth.require_phone');
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t('auth.require_password');
        this.isSignin = false;
        return false;
      }
      try {
        // if (this.name === 'testuser') {
        //   window.open('https://about.myanmarsoccer.xyz', '_self');
        // } else {
        const res = await this.axios.post(
          '/auth/login',
          {
            phone: this.name,
            password: this.password,
            roles: 'normal',
            fcm: localStorage.getItem('fcm'),
          },
        );
        localStorage.setItem('username', this.name);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);

        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        await this.fetchUser();
        this.$router.push('/home');
        // this.$router.go();
        // ..
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
        // }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async quickLogin() {
      this.isQuickLogin = true;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        await this.fetchUser();

        if (res.data.is_first_time === 1) {
          const platform =
            this.playHostPlatform ||
            this.$route.query.ref ||
            this.$route.query.referrer ||
            localStorage.getItem('user_platform_ref');
          if (platform) {
            try {
              await this.axios.post('/auth/update-user-platform', {
                user_platform: platform.toLowerCase(),
              });
            } catch (err) {
              console.error('Failed to update platform via query router param:', err);
            }
          }
        }

        this.$router.push('/home');
        Toast.success('Success!');
      } catch (err) {
        Toast.fail(this.$t('auth.fail_message'));
      }
      this.isQuickLogin = false;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  width: 100%;
  background-image: url("https://storage.googleapis.com/spacetech2/skk/LoginBg.avif");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-color: #030D05;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-cont {
  padding-top: 3rem;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: black;
  border: 1px solid black;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}
</style>
